<template>
    <div class="device-type-manange relative">
        <el-page-header @back="goBack" :content="title"></el-page-header>
        <div class="buttons" :style="{position: button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col class="search" :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">短信关键词：</span>
                <el-input v-model="content" placeholder="短信名称、内容模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">发送者：</span>
                <el-select
                    clearable
                    class="status" v-model="admin_id" placeholder="请选择发送者" style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allRole"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>


        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column width="50" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="140" prop="name" label="名称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="message_content" label="消息内容" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="user_name" label="发送者" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="return_code" label="发送结果" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="result_code" label="结果描述" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="160" prop="create_date" label="发送时间" align="center" label-class-name="label"></el-table-column>

        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {isMobile} from "@/api/order";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allRole: [
                    {
                        id: 1,
                        name: '超级管理员'
                    },
                    {
                        id: 2,
                        name: '后台管理员'
                    },
                    {
                        id: 3,
                        name: '特属服务专员'
                    },
                ],
                user_id: '',
                user_name: '',
                mobile: '',
                role_type: '',
                content: '',
                title: '',
                admin_id: '',
                button_position: 'absolute',
                is_mobile: false,
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
                this.is_mobile = true
            }
        },
        mounted() {
            // 获取系统消息列表
            this.user_id = this.$route.params.user_id;
            this.user_name = this.$route.params.user_name;
            let user_type = this.$route.params.user_name == 1 ? '特属服务对象' : '特属专家';
            let mobile = this.$route.params.mobile;
            this.title = `问候短信（${user_type}：${this.$route.params.user_name} - ${mobile}）`;
            this.getList();
            localStorage.setItem('prev_page', 'sms_user_list')
        },
        methods: {
            getList() {
                let params = {
                    servername: 'Ruyi_ContentServices',
                    method: 'getUserSmsList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: this.user_id,
                        content: this.content,
                        admin_id: this.admin_id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.content = "";
                this.admin_id = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$alert(data.message_content, '消息内容', {}).catch((e)=>{});
            },

            // 导出数据
            allPutMessage() {
                this.$router.push({
                    name: "systemMessageAdd", params: {
                        type: 2
                    }
                });
            },


            // 返回上一页
            goBack() {
                window.history.go(-1);
            },


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-select.status .el-input {
        width: 100%;
    }
    .search .el-input {
        width: 100% !important;
    }
</style>
